export default __webpack_public_path__ + "static/media/logo.f6ae2c4c.svg";